import React from "react";
import GradeIcon from "@mui/icons-material/Grade";
import CollectionsIcon from "@mui/icons-material/Collections";
import CollectionsBookmarkIcon from "@mui/icons-material/CollectionsBookmark";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { IoIosPaper } from "react-icons/io";
import { FaLayerGroup, FaGlobe } from "react-icons/fa";
import NunitoText from "./NunitoText";
import { HiFlag, HiUserGroup } from "react-icons/hi";
const bigIconStyle = (color) => ({ fontSize: 30, color: color });
const contentDivStyle = {
  fontSize: 12,
  fontWeight: 700,
  fontFamily: "var(--font-sans)",
  textAlign: "center",
  paddingInline: 20,
};
export default function Widget({
  title,
  content,
  marginLeft,
  marginTop,
  marginRight,
  marginBottom,
}) {
  let bigIcon, color, fontSize;
  //Set icons base on title
  switch (title) {
    case "Grade":
      color = "var(--color-accent-text)";
      bigIcon = <GradeIcon style={bigIconStyle(color)} />;
      break;
    case "Award Type":
      color = "var(--color-accent-text)";
      bigIcon = <GradeIcon style={bigIconStyle(color)} />;
      break;
    case "Collection":
      color = "var(--color-primary)";
      bigIcon = <CollectionsIcon style={bigIconStyle(color)} />;
      break;
    case "Competition":
      color = "var(--color-primary)";
      bigIcon = <IoIosPaper style={bigIconStyle(color)} />;
      break;
    case "Round":
      color = "var(--color-primary)";
      bigIcon = <AccessTimeIcon style={bigIconStyle(color)} />;
      break;
    case "Section":
    case "Level":
      color = "var(--color-primary)";
      bigIcon = <FaLayerGroup style={bigIconStyle(color)} />;
      break;
    case "Tasks Grouping":
      color = "var(--color-accent-text)";
      bigIcon = <CollectionsBookmarkIcon style={bigIconStyle(color)} />;
      break;
    case "Format":
      color = "var(--color-accent-text)";
      bigIcon = <FaGlobe style={bigIconStyle(color)} />;
      break;
    case "Group":
      color = "var(--color-primary)";
      bigIcon = <HiUserGroup style={bigIconStyle(color)} />;
      break;
    case "Countries":
      color = "var(--color-accent-text)";
      bigIcon = <HiFlag style={bigIconStyle(color)} />;
    default:
  }
  const divStyle = {
    borderRadius: 12,
    boxShadow: "0 0 0 1px var(--color-border), var(--shadow-small)",
    height: 110,
    minWidth: 160,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "center",
    marginLeft,
    marginTop,
    marginRight,
    marginBottom,
    paddingBlock: 10,
  };
  return (
    <div style={divStyle}>
      {bigIcon}
      <div style={contentDivStyle}>{content}</div>
      <NunitoText value={title} fontSize={16} fontWeight={500} color={color} />
    </div>
  );
}
